export type SavedBankAccountForLabel = {
  object: string;
  bankName?: string | null;
  last4?: string | null;
};

export type PaymentMethodDisplayParts = {
  kind: "card" | "ach";
  title: string;
  last4: string;
  brandForIcon?: string | null;
};

export const getSavedPaymentMethodParts = (
  bankAccount: SavedBankAccountForLabel
): PaymentMethodDisplayParts => {
  const last4 = bankAccount.last4?.trim() || "????";
  if (bankAccount.object === "card") {
    return {
      kind: "card",
      title: bankAccount.bankName?.trim() || "Card",
      last4,
      brandForIcon: bankAccount.bankName,
    };
  }
  return {
    kind: "ach",
    title: bankAccount.bankName?.trim() || "Bank account",
    last4,
  };
};

export const getNewCardPaymentMethodParts = (
  brand: string,
  last4: string
): PaymentMethodDisplayParts => {
  const raw = brand.trim();
  const title = raw ? raw.charAt(0).toUpperCase() + raw.slice(1) : "Card";
  return {
    kind: "card",
    title,
    last4: last4.trim() || "????",
    brandForIcon: brand,
  };
};

export const formatSavedPaymentMethodLabel = (bankAccount: SavedBankAccountForLabel): string => {
  const last4 = bankAccount.last4?.trim() || "????";
  if (bankAccount.object === "card") {
    const brand = bankAccount.bankName?.trim() || "Card";
    return `${brand} card ending in ${last4}`;
  }
  const bank = bankAccount.bankName?.trim() || "Bank account";
  return `${bank} bank account ending in ${last4}`;
};

export const formatNewCardPaymentMethodLabel = (brand: string, last4: string): string => {
  const raw = brand.trim();
  const displayBrand = raw ? raw.charAt(0).toUpperCase() + raw.slice(1) : "Card";
  const displayLast4 = last4.trim() || "????";
  return `${displayBrand} card ending in ${displayLast4}`;
};
